import {z} from 'zod';
import {OptionItem} from '../ui/option-card/option-card.model';

export const readingResolutions = ['EVERY_15_MINUTES', 'HOURLY', 'DAILY'] as const;

export const readingResolutionSchema = z.enum(readingResolutions);

export type ReadingResolution = z.infer<typeof readingResolutionSchema>;

export const defaultReadingResolution: ReadingResolution = 'DAILY';

export const minDaysBackInTime = 1;

export const maxDaysBackInTime = 31;

export const defaultDaysBackInTime = 30;

export const readingResolutionOptions: ReadonlyArray<OptionItem & {id: ReadingResolution}> = [
    {
        id: 'EVERY_15_MINUTES',
        titleKey: 'customizedexports_export_reading_resolution_quarter_hour_title',
        descriptionKey: 'customizedexports_export_reading_resolution_quarter_hour_desc',
    },
    {
        id: 'HOURLY',
        titleKey: 'customizedexports_export_reading_resolution_hourly_title',
        descriptionKey: 'customizedexports_export_reading_resolution_hourly_desc',
    },
    {
        id: 'DAILY',
        titleKey: 'customizedexports_export_reading_resolution_daily_title',
        descriptionKey: 'customizedexports_export_reading_resolution_daily_desc',
    },
];

export type ExportWeightTone = 'neutral' | 'warning' | 'danger';

export type ExportWeight = {
    filledPercent: number;
    tone: ExportWeightTone;
};

export const readingsPerMeterPerDay: Record<ReadingResolution, number> = {
    EVERY_15_MINUTES: 96,
    HOURLY: 24,
    DAILY: 1,
};

export const exportWeights: Record<ReadingResolution, ExportWeight> = {
    EVERY_15_MINUTES: {
        filledPercent: 100,
        tone: 'danger',
    },
    HOURLY: {
        filledPercent: 66,
        tone: 'warning',
    },
    DAILY: {
        filledPercent: 12,
        tone: 'neutral',
    },
};
